module.exports = __webpack_public_path__ + "static/grbmember5-fc800e69163b32e8e27f6e05e82759f7.svg";